<template>
    <div class="p360-chatbot-wrapper">
        <transition name="panel-fade">
            <div v-if="isOpen" class="chat-panel" :style="panelStyle">
                <div class="chat-header">
                    <div class="header-content">
                        <img src="https://app.personhood360.com.au/logo.svg" alt="Logo" class="header-logo"
                            @error="handleLogoError" />
                        <div>
                            <div class="header-title">Help Assistant</div>
                            <div class="header-subtitle">Ask me anything about Personhood360</div>
                        </div>
                    </div>
                    <button class="close-btn" @click="SET_OPEN(false)">✕</button>
                </div>

                <div class="messages-container p360-chatbot-scrollbar" ref="scrollContainer">
                    <div v-if="messages.length === 0 && !isLoading" class="welcome-screen">
                        <div class="bot-icon-large">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                                xmlns="http://www.w3.org/2000/svg">
                                <rect x="3" y="9" width="18" height="12" rx="3"></rect>
                                <circle cx="8.5" cy="14.5" r="1"></circle>
                                <circle cx="15.5" cy="14.5" r="1"></circle>
                                <path d="M12 9V6"></path>
                                <path d="M9 6h6"></path>
                                <path d="M10 18h4"></path>
                                <path d="M7 21v1"></path>
                                <path d="M17 21v1"></path>
                            </svg>
                        </div>
                        <h3>Hi there! 👋</h3>
                        <p>I can help you navigate Personhood360.<br />Try one of these or ask your own question.</p>

                        <div class="starter-questions">
                            <button v-for="(q, i) in starterQuestions" :key="i" class="starter-pill"
                                @click="sendMessage(q)">
                                {{ q }}
                            </button>
                        </div>
                    </div>

                    <div v-for="(msg, i) in messages" :key="i"
                        :class="['bubble-row', msg.role === 'user' ? 'user-row' : 'bot-row']">
                        <div v-if="msg.role === 'bot'" class="bot-avatar">
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2">
                                <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
                            </svg>
                        </div>
                        <div class="bubble">{{ msg.text }}</div>
                    </div>

                    <div v-if="isLoading" class="bubble-row bot-row">
                        <div class="bot-avatar"><svg width="16" height="16" viewBox="0 0 24 24" fill="none"
                                stroke="white" stroke-width="2">
                                <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
                            </svg></div>
                        <div class="bubble typing-bubble">
                            <div class="dot"></div>
                            <div class="dot"></div>
                            <div class="dot"></div>
                        </div>
                    </div>
                    <div ref="messagesEnd"></div>
                </div>

                <form class="input-area" @submit.prevent="handleInputSubmit">
                    <input v-model="userInput" ref="inputField" type="text" placeholder="Type your question..."
                        :disabled="isLoading" />
                    <button type="submit" :disabled="!userInput.trim() || isLoading" class="send-btn">
                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2"
                            stroke-linecap="round" stroke-linejoin="round">
                            <line x1="22" y1="2" x2="11" y2="13" />
                            <polygon points="22 2 15 22 11 13 2 9 22 2" />
                        </svg>
                    </button>
                </form>
            </div>
        </transition>

        <button class="fab" :class="{ 'fab-open': isOpen }" @click="TOGGLE_CHAT">
            <svg v-if="!isOpen" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2"
                stroke-linecap="round" stroke-linejoin="round">
                <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
            </svg>
            <span v-else style="color: white; font-size: 24px;">✕</span>
        </button>
    </div>
</template>

<script>

import { mapState, mapMutations, mapActions } from 'vuex';
export default {
    data() {
        return {
            userInput: "",
            starterQuestions: [
                "How do I create a learning story?",
                "What do the matrix colours mean?",
                "How do I add a new child?",
                "What are the Core Skills?",
                "How do I access Professional Development?",
                "What does the parent portal show?",
            ],
            theme: {
                navy: "#27378E",
                blue: "#289AD5",
                border: "#E0E0E0",
            }
        };
    },
    computed: {
        ...mapState('chatBot', ['isOpen', 'messages', 'isLoading']),
        panelStyle() {
            return {
                '--primary-navy': this.theme.navy,
                '--primary-blue': this.theme.blue,
                '--border-color': this.theme.border
            };
        }
    },
    watch: {
        messages() { this.scrollToBottom(); },
        isLoading() { this.scrollToBottom(); }
    },
    methods: {

        ...mapMutations('chatBot', ['TOGGLE_CHAT', 'SET_OPEN']),
        ...mapActions('chatBot', ['sendMessage']),

        handleLogoError(e) {
            e.target.style.display = 'none';
        },
        handleInputSubmit() {
            this.sendMessage(this.userInput);
            this.userInput = ''
        },
        scrollToBottom() {
            this.$nextTick(() => {
                const container = this.$refs.scrollContainer;
                if (container) {
                    container.scrollTop = container.scrollHeight;
                }
            });
        }
    }
};
</script>
